import React from 'react'

const Manual_ordenes_compra_revertir_orden_completa = () => {
  return (
    <>
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
        <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Ordenes de Compra - Revertir Orden Completa
        </h2>
        <p className="text-lg text-gray-700 mb-6">
        La guía ofrece un proceso detallado para revertir órdenes de compra, incluyendo la introducción de
        motivos y confirmación de la acción. Facilita la edición, visualización, cancelación y descarga de pedidos,
        mejorando su gestión con eficiencia y confianza.
        </p>
        <iframe

        src="https://scribehow.com/embed/Ordenes_de_Compra__Revertir_Orden_Completa__ME6DY93dQU-GQPPYBLv6fQ?as=scrollable"
        className="scribe-iframe-general-23"
        width="100%"
        height="3500"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
        ></iframe>
        </div>
    </div>
    </>
  )
}

export default Manual_ordenes_compra_revertir_orden_completa